/**
 * @generated SignedSource<<7b470fe292e6c00e74ef2bec86987ee4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewIssueItemAssignees_issue$data = {
  readonly assignedUsers: ReadonlyArray<{
    readonly user: {
      readonly name: string;
    } | null;
  }>;
  readonly " $fragmentType": "WidgetIssueOverviewIssueItemAssignees_issue";
};
export type WidgetIssueOverviewIssueItemAssignees_issue$key = {
  readonly " $data"?: WidgetIssueOverviewIssueItemAssignees_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItemAssignees_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueOverviewIssueItemAssignees_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueAssignedUser",
      "kind": "LinkedField",
      "name": "assignedUsers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "b56118d92466d521fc131e16438a1820";

export default node;
